(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bimm-bahnsteig-studio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bimm-studio-home')) {
    customElements.define('bimm-studio-home', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const start = this.querySelector('[data-studio-start]');
        const planner = this.querySelector('.bimm-studio-home__planner');
        start.setAttribute('aria-expanded', 'false');
        start.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!this.querySelector('iframe')) {
            const frame = this.querySelector('template').content.firstElementChild.cloneNode(true);
            frame.src = frame.dataset.src;
            this.querySelector('[data-studio-mount]').append(frame);
          }
          planner.hidden = false;
          start.setAttribute('aria-expanded', 'true');
          planner.scrollIntoView({block: 'start', behavior: 'instant'});
          this.querySelector('[data-studio-close]').focus({preventScroll: true});
        });
        this.querySelector('[data-studio-close]').addEventListener('click', () => {
          planner.hidden = true;
          start.setAttribute('aria-expanded', 'false');
          start.focus();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bimm-bahnsteige"] && !Shopify.designMode) return;
  try {
    
(()=>{const root=document.querySelector('.ep-review');if(!root)return;
function navigate(){let h=location.hash.slice(1)||root.dataset.defaultArea||'uebersicht';if(h==='epoche-6')h='e56-75';const target=root.querySelector('[id="'+CSS.escape(h)+'"]');let panel=target?.classList.contains('ep-panel')?target:target?.closest('.ep-panel');if(!panel)panel=root.querySelector('#uebersicht');root.querySelectorAll('.ep-panel').forEach(p=>p.hidden=p!==panel);root.querySelectorAll('[data-area]').forEach(a=>{if(a.dataset.area===(panel.dataset.gauge||panel.id))a.setAttribute('aria-current','page');else a.removeAttribute('aria-current');});const systems=[...panel.querySelectorAll('.ep-system')];const active=systems.find(s=>s.id===h)||target?.closest('.ep-system')||systems[0];systems.forEach(s=>s.hidden=s!==active);panel.querySelectorAll('[data-system]').forEach(a=>{if(a.dataset.system===active?.id)a.setAttribute('aria-current','page');else a.removeAttribute('aria-current');});}

root.querySelectorAll('[data-live-finish]').forEach(s=>s.addEventListener('change',()=>{const o=s.selectedOptions[0],c=s.closest('.ep-card'),img=c.querySelector('img');if(img&&o.dataset.image){img.src=o.dataset.image;img.removeAttribute('srcset');img.alt=o.dataset.alt||c.querySelector('h3').textContent+' · '+o.textContent+' · einfarbig graues PLA';}c.querySelector('[data-live-price]').textContent=o.dataset.price;c.querySelectorAll('[data-product-link]').forEach(a=>a.href=o.dataset.url);}));
const paint=JSON.parse(root.querySelector('#ep-paint-data').textContent);root.querySelector('#ep-paint-finish')?.addEventListener('change',e=>{const i=root.querySelector('#ep-paint-image');i.src=paint[e.target.value];i.alt='Bemalbeispiel: dunkle Kante, '+e.target.value+'. Lieferung einfarbig grau, unbemalt.';});

root.addEventListener('click',event=>{
const opener=event.target.closest('[data-wide-open]');
if(opener){root.querySelector('#'+CSS.escape(opener.dataset.wideOpen))?.showModal();return;}
if(event.target.closest('[data-wide-close]'))event.target.closest('dialog').close();
if(event.target.matches('dialog.ep-dialog')){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}
});
root.addEventListener('change',event=>{
if(!event.target.matches('[data-wide-finish]'))return;
const o=event.target.selectedOptions[0],card=event.target.closest('.ep-wide-card');
card.querySelectorAll('.ep-wide-main').forEach(img=>{img.src=o.dataset.image;img.alt=card.querySelector('h3').textContent+' · '+o.value+' · graues PLA, unbemalt';});
card.querySelectorAll('[data-wide-selected]').forEach(label=>label.textContent=o.value);
});

window.addEventListener('hashchange',navigate);navigate();})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bimo-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bimo-announcements')) {
    customElements.define('bimo-announcements', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.messages = [...this.querySelectorAll('.bimo-news-message')];
        this.position = 0;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
        this.hovered = false;
        this.editing = false;
        this.interval = Math.max(4000, Number(this.dataset.interval) || 6000);
        this.pauseButton = this.querySelector('[data-pause]');
        if (this.messages.length < 2) return;
        this.querySelectorAll('button').forEach(button => { button.hidden = false; });
        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.position - 1, true), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.position + 1, true), options);
        this.pauseButton.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updatePause();
          this.schedule();
        }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => this.schedule(), options);
        this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.reduced.addEventListener('change', () => {
          if (this.reduced.matches) this.paused = true;
          this.updatePause();
          this.schedule();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.messages.findIndex(message => message.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editing = true;
          this.show(index, true);
        }, options);
        document.addEventListener('shopify:block:deselect', () => { this.editing = false; this.schedule(); }, options);
        this.updatePause();
        this.schedule();
      }
      show(index, manual = false) {
        this.position = (index + this.messages.length) % this.messages.length;
        this.querySelector('.bimo-news-messages').setAttribute('aria-live', manual ? 'polite' : 'off');
        this.messages.forEach((message, i) => {
          const active = i === this.position;
          message.classList.toggle('is-active', active);
          message.setAttribute('aria-hidden', String(!active));
          message.inert = !active;
        });
        this.schedule();
      }
      updatePause() {
        this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
        this.pauseButton.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || this.paused || this.hovered || this.editing || document.hidden || this.contains(document.activeElement) || this.messages.length < 2) return;
        this.timer = setTimeout(() => this.show(this.position + 1), this.interval);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bimo-header"]) return;
  try {
    
document.addEventListener('click',event=>{document.querySelectorAll('.bimo-nav-group[open],.bimo-mobile-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.removeAttribute('open')})});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.bimo-nav-group[open],.bimo-mobile-menu[open]').forEach(menu=>{menu.removeAttribute('open');menu.querySelector('summary').focus()})});
document.addEventListener('toggle',event=>{if(event.target.matches('.bimo-nav-group[open]'))document.querySelectorAll('.bimo-nav-group[open]').forEach(menu=>{if(menu!==event.target)menu.removeAttribute('open')})},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modelpod-wall"]) return;
  try {
    
(function(scope){
  'use strict';
  const TYPES = [
    {key:'cube',name:'CUBE',w:241,d:241,h:246.5,pitch:250,handle:'modelpod',tone:'#a9dbe8'},
    {key:'double',name:'DOUBLE CUBE',w:485,d:241,h:246.5,pitch:250,handle:'modelpod-vorbestellung-versand-spatestens-ab-01-06-2026',tone:'#c0d0e9'},
    {key:'nano',name:'NANO CUBE',w:121,d:121,h:126.5,pitch:125,handle:'modelpod-midi',tone:'#bdd7c5'},
    {key:'rocket',name:'ROCKET',w:121,d:121,h:246.5,pitch:250,handle:'modelpod-mini',tone:'#efd0a1'},
    {key:'horizon',name:'HORIZON',w:365,d:121,h:126.5,pitch:125,handle:'modelpod-maxi',tone:'#d1c4e8'}
  ];
  const BY_KEY=Object.fromEntries(TYPES.map(t=>[t.key,t]));
  const EPS=.05, GAP=3, MAX=120;
  const type=p=>BY_KEY[p.type], round=n=>Math.round(n*10)/10;
  const pitch=(t,legacy=false)=>legacy?t.h-1.5:t.pitch;
  const height=(t,legacy=false)=>pitch(t,legacy)+1.5;
  const overlaps=(a,b,legacy=false)=>a.x< b.x+type(b).w-EPS && a.x+type(a).w>b.x+EPS && a.y<b.y+pitch(type(b),legacy)-EPS && a.y+pitch(type(a),legacy)>b.y+EPS;
  function support(p,items,legacy=false){
    if(Math.abs(p.y)<EPS)return {ok:true,ground:true,spacers:0,parents:[]};
    const t=type(p), bases=items.filter(b=>b.id!==p.id&&Math.abs(b.y+pitch(type(b),legacy)-p.y)<EPS);
    const feet=[p.x+12.5,p.x+t.w-12.5];
    let spacers=0; const parents=[];
    for(const x of feet){
      const base=bases.find(b=>x-7.5>=b.x-EPS&&x+7.5<=b.x+type(b).w+EPS&&type(b).d>=t.d-EPS);
      if(!base)return {ok:false,ground:false,spacers:0,parents,reason:bases.some(b=>x>=b.x&&x<=b.x+type(b).w&&type(b).d<t.d)?'depth':'support'};
      parents.push(base.id);
      const bt=type(base), onCorner=Math.min(Math.abs(x-(base.x+12.5)),Math.abs(x-(base.x+bt.w-12.5)))<EPS;
      if(!onCorner)spacers+=2;
      else if(bt.d!==t.d)spacers+=1;
    }
    return {ok:true,ground:false,spacers,parents:[...new Set(parents)]};
  }
  function check(p,items,wall,legacy=false){
    if(!p||!type(p)||![p.x,p.y].every(Number.isFinite))return {ok:false,reason:'invalid'};
    const t=type(p);
    if(p.x<-EPS||p.y<-EPS||p.x+t.w>wall.w+EPS||p.y+height(t,legacy)>wall.h+EPS)return {ok:false,reason:'bounds'};
    if(items.some(b=>b.id!==p.id&&overlaps(p,b,legacy)))return {ok:false,reason:'overlap'};
    return support(p,items,legacy);
  }
  function validate(items,wall,legacy=false){
    if(!wall||![wall.w,wall.h].every(v=>Number.isFinite(v)&&v>=500&&v<=4000))return {ok:false,reason:'wall'};
    if(items.length>MAX||new Set(items.map(p=>p.id)).size!==items.length)return {ok:false,reason:'invalid'};
    for(const p of items){const c=check(p,items,wall,legacy);if(!c.ok)return {...c,id:p.id};}
    return {ok:true};
  }
  function candidateXs(t,items,wall,want){
    const raw=[0,wall.w-t.w];
    for(const b of items){const bt=type(b);raw.push(b.x,b.x+bt.w-t.w,b.x+bt.w+GAP,b.x-t.w-GAP,b.x+(bt.w-t.w)/2);}
    if(Number.isFinite(want))raw.push(round(want));
    return [...new Set(raw.filter(x=>x>=-EPS&&x+t.w<=wall.w+EPS).map(x=>round(Math.max(0,x))))];
  }
  function fit(kind,items,wall,id,want){
    const t=BY_KEY[kind];if(!t)return null;
    const rest=items.filter(p=>p.id!==id);if(rest.length>=MAX)return null;
    const xs=candidateXs(t,rest,wall,want?.x);
    const ys=[...new Set([0,...rest.map(p=>round(p.y+type(p).pitch))])];
    let best=null,score=Infinity;
    for(const y of ys)for(const x of xs){
      const p={id,type:kind,x,y};
      if(!check(p,rest,wall).ok)continue;
      const all=[...rest,p];
      if(!validate(all,wall).ok)continue;
      const s=want?Math.hypot(x-want.x,(y-want.y)*1.2):y*10000+x;
      if(s<score){score=s;best=p;}
    }
    return best;
  }
  function snap(kind,items,wall,id,want,tolerance=45){
    const rest=items.filter(p=>p.id!==id),t=BY_KEY[kind];
    if(!t)return null;
    const xs=candidateXs(t,rest,wall).filter(x=>Math.abs(x-want.x)<=tolerance);
    const x=xs.sort((a,b)=>Math.abs(a-want.x)-Math.abs(b-want.x))[0]??round(want.x);
    const ys=[0,...rest.map(p=>round(p.y+type(p).pitch))].filter(y=>Math.abs(y-want.y)<=tolerance);
    const y=ys.sort((a,b)=>Math.abs(a-want.y)-Math.abs(b-want.y))[0]??round(want.y);
    const p={id,type:kind,x,y};const result=validate([...rest,p],wall);
    return {pod:p,...result};
  }
  function metrics(items){
    const counts=Object.fromEntries(TYPES.map(t=>[t.key,items.filter(p=>p.type===t.key).length]));
    const minX=items.length?Math.min(...items.map(p=>p.x)):0;
    return {count:items.length,counts,width:items.length?round(Math.max(...items.map(p=>p.x+type(p).w))-minX):0,height:items.length?round(Math.max(...items.map(p=>p.y+height(type(p))))):0,depth:items.length?Math.max(...items.map(p=>type(p).d)):0,spacers:items.reduce((n,p)=>n+support(p,items).spacers,0)};
  }
  function preset(name,wall){
    let items=[],id=0;
    const add=(kind,x,y)=>{const p={id:++id,type:kind,x,y};if(check(p,items,wall).ok)items.push(p);};
    if(name==='empty')return [];
    if(name==='mixed'){
      const rows=Math.min(6,Math.floor((wall.h-1.5)/250));
      if(wall.w>=1465){
        for(let r=0;r<rows;r++){
          if(r%2===0){add('double',0,r*250);add('cube',488,r*250);}
          else{add('cube',0,r*250);add('double',244,r*250);}
        }
        add('horizon',732,0);
        for(const x of [732,854,976])add('nano',x,125);
        for(const x of [732,854,976])add('rocket',x,250);
        add('horizon',732,500);add('horizon',732,625);add('horizon',732,750);
        for(const x of [732,854,976])add('rocket',x,875);
        for(const x of [1100,1222,1344])add('rocket',x,0);
        add('horizon',1100,250);add('horizon',1100,375);
        for(const x of [1100,1222,1344])add('nano',x,500);
        for(const x of [1100,1222,1344])add('rocket',x,625);
        add('horizon',1100,875);add('horizon',1100,1000);
        return items;
      }
      for(let r=0;r<4;r++)for(const k of ['cube','rocket','nano','horizon','double']){const p=fit(k,items,wall,++id);if(p)items.push(p);}
      return items;
    }
    const groups=Math.floor((wall.w+GAP)/732), rows=Math.min(7,Math.floor((wall.h-1.5)/250));
    if(groups){
      for(let r=0;r<rows;r++)for(let c=0;c<groups;c++){
        const x=c*732;
        if(r%2===0){add('double',x,r*250);add('cube',x+488,r*250);}
        else{add('cube',x,r*250);add('double',x+244,r*250);}
      }
    }else{for(let r=0;r<5;r++){const p=fit('cube',items,wall,++id);if(p)items.push(p);}}
    return items;
  }
  function encode(wall,items){
    return {v:2,w:wall.w,h:wall.h,p:items.map(p=>[TYPES.findIndex(t=>t.key===p.type),round(p.x),round(p.y)])};
  }
  function decode(data){
    if(!data||![1,2].includes(data.v)||!Array.isArray(data.p)||data.p.length>MAX)throw Error('invalid');
    const wall={w:data.w,h:data.h};
    let items=data.p.map((a,i)=>{if(!Array.isArray(a)||a.length!==3||!Number.isInteger(a[0])||!TYPES[a[0]])throw Error('invalid');return {id:i+1,type:TYPES[a[0]].key,x:a[1],y:a[2]};});
    if(data.v===1){
      if(!validate(items,wall,true).ok)throw Error('invalid');
      const moved=new Map();
      for(const p of [...items].sort((a,b)=>a.y-b.y)){
        const base=support(p,items,true);
        const y=base.ground?0:Math.max(...base.parents.map(id=>{const b=moved.get(id);return b.y+type(b).pitch}));
        moved.set(p.id,{...p,y:round(y)});
      }
      items=items.map(p=>moved.get(p.id));
      wall.h=Math.max(wall.h,Math.ceil(metrics(items).height));
    }
    if(!validate(items,wall).ok)throw Error('invalid');return {wall,items};
  }
  const api={TYPES,BY_KEY,GAP,MAX,type,height,check,support,validate,fit,snap,metrics,preset,encode,decode};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;else scope.ModelPodWallEngine=api;
})(typeof window!=='undefined'?window:globalThis);

(function(){
  'use strict';
  const E=window.ModelPodWallEngine, NS='http://www.w3.org/2000/svg';
  const esc=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  class WallPlanner{
    constructor(root){
      if(root.dataset.initialized)return;root.dataset.initialized='true';this.root=root;
      this.words=JSON.parse(root.querySelector('[data-wall-i18n]').textContent);
      this.wall={w:1500,h:2000};this.items=[];this.selected=null;this.next=1;this.view='front';this.light=false;this.zoom=1;this.pending=null;this.drag=null;this.undo=[];this.redo=[];this.ghost=null;this.storage=true;this.prefix='mpw'+Math.random().toString(36).slice(2,8);
      this.stage=this.q('[data-stage]');this.status=this.q('[data-status]');this.form=this.q('.mpc-size');
      this.catalog();this.restore();this.bind();this.render();
    }
    q(s){return this.root.querySelector(s)}
    t(k,vars={}){return Object.entries(vars).reduce((s,[key,v])=>s.replaceAll('{'+key+'}',String(v)),this.words[k]||k)}
    fmt(n){return Number(n).toLocaleString('de-DE',{maximumFractionDigits:2})}
    cm(n){return this.fmt(n/10)+' cm'}
    message(k,vars){this.status.textContent=this.t(k,vars)}
    restore(){
      let source='',loaded=null;
      try{
        const hash=new URLSearchParams(location.hash.slice(1));
        if(hash.has('wand')){source='shared_loaded';const s=hash.get('wand');if(s.length>18000)throw Error();loaded=E.decode(JSON.parse(atob(s.replace(/-/g,'+').replace(/_/g,'/'))));}
        else{const s=localStorage.getItem('modelpod-wall-v1');if(s){source='restored';loaded=E.decode(JSON.parse(s));}}
      }catch(e){this.message('invalid_link');}
      if(loaded){this.wall=loaded.wall;this.items=loaded.items;this.message(source)}else{this.items=E.preset('offset',this.wall)}
      this.next=Math.max(0,...this.items.map(p=>p.id))+1;
      this.form.elements['wall-width'].value=this.wall.w/10;this.form.elements['wall-height'].value=this.wall.h/10;
    }
    snapshot(){return JSON.stringify({wall:this.wall,items:this.items,selected:this.selected})}
    commit(items,wall=this.wall,selected=this.selected){
      const result=E.validate(items,wall);if(!result.ok){this.message('reason_'+result.reason);return false}
      this.undo.push(this.snapshot());if(this.undo.length>50)this.undo.shift();this.redo=[];
      this.items=items;this.wall={...wall};this.selected=selected;this.pending=null;this.ghost=null;this.persist();this.render();return true;
    }
    persist(){try{localStorage.setItem('modelpod-wall-v1',JSON.stringify(E.encode(this.wall,this.items)))}catch(e){this.storage=false}}
    history(direction){const from=this[direction],to=this[direction==='undo'?'redo':'undo'];if(!from.length)return;to.push(this.snapshot());const state=JSON.parse(from.pop());this.wall=state.wall;this.items=state.items;this.selected=state.selected;this.pending=null;this.next=Math.max(this.next,...this.items.map(p=>p.id+1));this.persist();this.render();this.message(direction)}
    catalog(){
      this.q('[data-types]').innerHTML=E.TYPES.map(t=>`<div class="mpc-type" data-type="${t.key}"><button type="button" class="mpc-pick" data-pick="${t.key}" aria-label="${esc(this.t('placing',{name:t.name}))}"><svg viewBox="0 0 110 50" aria-hidden="true">${this.mini(t)}</svg><b>${t.name}</b><small>${this.fmt(t.w)} × ${this.fmt(t.d)} × ${this.fmt(t.h)}</small></button><button class="mpc-add" type="button" data-add="${t.key}" aria-label="${esc(this.t('add',{name:t.name}))}">+</button></div>`).join('');
    }
    mini(t){const scale=Math.min(90/t.w,42/t.h),w=t.w*scale,h=t.h*scale,x=6,y=47-h;return `<rect x="${x+4}" y="${y-4}" width="${w}" height="${h}" rx="1" fill="#a8b4ba"/><rect x="${x}" y="${y}" width="${w}" height="${h}" rx="1" fill="#e3e5e3"/><rect x="${x+3}" y="${y+4}" width="${Math.max(w-6,3)}" height="${Math.max(h-8,3)}" fill="#5a655f"/><path d="M ${x+4} ${y+h-5} L ${x+w-4} ${y+5}" stroke="#b9eaf8" opacity=".35"/><path d="M ${x+1} ${y} V ${y+h} M ${x+w-1} ${y} V ${y+h}" stroke="#060e17" stroke-width="3"/>`}
    bind(){
      this.form.addEventListener('submit',event=>{event.preventDefault();const w=Number(this.form.elements['wall-width'].value)*10,h=Number(this.form.elements['wall-height'].value)*10,newWall={w:Math.round(w),h:Math.round(h)};const result=E.validate(this.items,newWall);if(!result.ok){this.message(result.reason==='wall'?'reason_wall':'resize_error');this.form.elements['wall-width'].value=this.wall.w/10;this.form.elements['wall-height'].value=this.wall.h/10;return}this.commit([...this.items],newWall);this.message('resized')});
      this.q('[data-light]').addEventListener('change',e=>{this.light=e.target.checked;this.scene()});
      this.q('[data-preset]').addEventListener('change',e=>{this.commit(E.preset(e.target.value,this.wall),this.wall,null);this.next=Math.max(0,...this.items.map(p=>p.id))+1;this.message('preset_loaded')});
      this.root.addEventListener('click',e=>{
        if(this.suppressClick){
          this.suppressClick=false;
          if(e.target===this.root||e.target.closest('[data-stage], [data-pick]'))return;
        }
        const add=e.target.closest('[data-add]'),pick=e.target.closest('[data-pick]'),view=e.target.closest('[data-view]'),action=e.target.closest('[data-action]');
        if(add){this.add(add.dataset.add);return}
        if(pick){this.pending=pick.dataset.pick;this.view='front';this.message('placing',{name:E.BY_KEY[this.pending].name});this.render();return}
        if(view){this.view=view.dataset.view;this.pending=null;this.render();return}
        if(action){this.action(action.dataset.action);return}
        if(e.target.closest('[data-stage]')){
          if(this.pending){const point=this.point(e),t=E.BY_KEY[this.pending];this.place(this.pending,{x:point.x-t.w/2,y:this.wall.h-point.y-E.height(t)/2});return}
          const pod=e.target.closest('[data-pod]');this.selected=pod?Number(pod.dataset.pod):null;this.render();
        }
      });
      this.root.addEventListener('keydown',e=>{
        if(e.target.matches('input,select,textarea'))return;
        if((e.ctrlKey||e.metaKey)&&e.key.toLowerCase()==='z'){e.preventDefault();this.history(e.shiftKey?'redo':'undo');return}
        if(e.key==='Escape'){this.action('cancel');return}
        const pod=e.target.closest('[data-pod]');if(!pod)return;this.selected=Number(pod.dataset.pod);
        if(e.key==='Enter'||e.key===' '){e.preventDefault();this.render();return}
        if(['Delete','Backspace'].includes(e.key)){e.preventDefault();this.action('remove')}
        if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.action(e.key==='ArrowLeft'?'left':'right')}
      });
      this.root.addEventListener('pointerdown',e=>this.pointerDown(e));
      this.root.addEventListener('pointermove',e=>this.pointerMove(e));
      this.root.addEventListener('pointerup',e=>this.pointerUp(e));
      this.root.addEventListener('pointercancel',()=>{this.drag=null;this.ghost=null;this.stage.classList.remove('is-dragging');this.scene()});
    }
    add(kind){const p=E.fit(kind,this.items,this.wall,this.next++);if(!p){this.message('no_room');return}this.commit([...this.items,p],this.wall,p.id);this.message('added',{name:E.type(p).name})}
    place(kind,want){const r=E.snap(kind,this.items,this.wall,this.next,want,this.tolerance());if(!r.ok){this.message('reason_'+r.reason);return}this.next++;this.commit([...this.items,r.pod],this.wall,r.pod.id);this.message('added',{name:E.BY_KEY[kind].name})}
    point(e){const svg=this.stage.querySelector('svg'),p=svg.createSVGPoint();p.x=e.clientX;p.y=e.clientY;return p.matrixTransform(svg.getScreenCTM().inverse())}
    tolerance(){const svg=this.stage.querySelector('svg');return 20/Math.max(.01,svg.getScreenCTM().a)}
    pointerDown(e){
      if(e.button!==0)return;const pick=e.target.closest('[data-pick]'),pod=e.target.closest('[data-pod]');
      if(!pick&&(!pod||this.view!=='front'))return;
      if(this.pending&&pod)return;
      const existing=pod?this.items.find(p=>p.id===Number(pod.dataset.pod)):null;
      const pos=this.point(e);
      this.drag={pointerId:e.pointerId,startX:e.clientX,startY:e.clientY,kind:pick?pick.dataset.pick:existing.type,id:existing?.id??this.next,existing,offset:existing?{x:pos.x-existing.x,y:pos.y-(this.wall.h-existing.y-E.height(E.type(existing)))}:null,moved:false};
      this.root.setPointerCapture(e.pointerId);
    }
    pointerMove(e){
      const d=this.drag;if(!d||d.pointerId!==e.pointerId)return;
      if(!d.moved&&Math.hypot(e.clientX-d.startX,e.clientY-d.startY)<6)return;
      d.moved=true;this.view='front';this.pending=null;this.stage.classList.add('is-dragging');
      const rect=this.stage.getBoundingClientRect();
      if(e.clientX<rect.left||e.clientX>rect.right||e.clientY<rect.top||e.clientY>rect.bottom){this.ghost=null;this.scene();return}
      const point=this.point(e),t=E.BY_KEY[d.kind],offset=d.offset||{x:t.w/2,y:E.height(t)/2};
      this.ghost=E.snap(d.kind,this.items,this.wall,d.id,{x:point.x-offset.x,y:this.wall.h-point.y+offset.y-E.height(t)},this.tolerance());this.scene();
    }
    pointerUp(e){
      const d=this.drag;if(!d||d.pointerId!==e.pointerId)return;this.drag=null;this.stage.classList.remove('is-dragging');
      try{this.root.releasePointerCapture(e.pointerId)}catch(error){}
      this.suppressClick=true;setTimeout(()=>{this.suppressClick=false},250);
      if(!d.moved){
        if(d.existing){this.selected=d.existing.id;this.render()}
        else{this.pending=d.kind;this.view='front';this.message('placing',{name:E.BY_KEY[d.kind].name});this.render()}
        return;
      }
      const r=this.ghost;this.ghost=null;
      if(!r){this.scene();return}
      if(!r.ok){this.message('reason_'+r.reason);this.scene();return}
      if(!d.existing)this.next++;
      this.commit([...this.items.filter(p=>p.id!==d.id),r.pod],this.wall,r.pod.id);this.message(d.existing?'moved':'added',{name:E.BY_KEY[d.kind].name});
    }
    action(name){
      const p=this.items.find(i=>i.id===this.selected);
      if(name==='undo'||name==='redo'){this.history(name);return}
      if(name==='cancel'){this.pending=null;this.ghost=null;this.message('canvas_hint');this.render();return}
      if(name==='zoom-in'||name==='zoom-out'){this.zoom=Math.max(1,Math.min(2.5,this.zoom+(name==='zoom-in'?.5:-.5)));this.scene();this.q('[data-zoom]').textContent=this.zoom*100+' %';return}
      if(name==='share'){this.share();return}
      if(name==='export'){this.export();return}
      if(!p)return;
      if(name==='duplicate'){this.add(p.type);return}
      if(name==='remove'){if(this.commit(this.items.filter(i=>i.id!==p.id),this.wall,null))this.message('removed');return}
      if(name==='left'||name==='right'){
        const moved={...p,x:Math.round((p.x+(name==='left'?-10:10))*10)/10};
        if(this.commit(this.items.map(i=>i.id===p.id?moved:i)))this.message('moved',{name:E.type(p).name});
      }
    }
    share(){
      const data=JSON.stringify(E.encode(this.wall,this.items)),encoded=btoa(data).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
      const url=new URL(location.href);url.hash='wand='+encoded;
      const field=this.q('[data-share-url]');
      const fallback=()=>{field.hidden=false;field.value=url.href;field.focus();field.select();this.message('share_fallback')};
      if(navigator.clipboard?.writeText)navigator.clipboard.writeText(url.href).then(()=>{field.hidden=true;this.message('shared')}).catch(fallback);else fallback();
    }
    export(){
      const svg=this.stage.querySelector('svg').cloneNode(true);svg.setAttribute('xmlns',NS);svg.removeAttribute('style');svg.setAttribute('width','1600');svg.setAttribute('height',Math.round(1600*(this.wall.h+180)/(this.wall.w+220)).toString());
      svg.querySelectorAll('[data-pod]').forEach(g=>{g.removeAttribute('tabindex');g.removeAttribute('role')});
      const title=document.createElementNS(NS,'title');title.textContent=this.t('plan_title');svg.prepend(title);
      const description=document.createElementNS(NS,'desc');description.textContent=this.t('footnote')+' | '+E.TYPES.map(t=>`${E.metrics(this.items).counts[t.key]} × ${t.name}`).join(', ');svg.prepend(description);
      const blob=new Blob([new XMLSerializer().serializeToString(svg)],{type:'image/svg+xml;charset=utf-8'}),url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download='ModelPod-Wand.svg';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);this.message('exported');
    }
    render(){
      this.form.elements['wall-width'].value=this.wall.w/10;this.form.elements['wall-height'].value=this.wall.h/10;
      this.root.querySelectorAll('[data-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.view===this.view)));
      this.root.querySelectorAll('[data-type]').forEach(b=>b.classList.toggle('is-pending',b.dataset.type===this.pending));
      this.q('[data-action=cancel]').hidden=!this.pending;
      this.q('[data-hint]').textContent=this.t(this.view==='space'?'space_hint':this.pending?'placing':'canvas_hint',this.pending?{name:E.BY_KEY[this.pending].name}:{});
      this.q('[data-action=undo]').disabled=!this.undo.length;this.q('[data-action=redo]').disabled=!this.redo.length;
      const m=E.metrics(this.items);this.q('[data-count]').textContent=m.count;this.q('[data-used]').textContent=this.fmt(m.width/10)+' × '+this.cm(m.height);this.q('[data-depth]').textContent=this.cm(m.depth);
      this.q('[data-bom]').innerHTML=m.count?E.TYPES.filter(t=>m.counts[t.key]).map(t=>`<div class="mpc-bom-row"><a href="/products/${t.handle}" title="${esc(this.t('product'))}">${t.name} <span aria-hidden="true">↗</span></a><strong>${m.counts[t.key]}×</strong></div>`).join(''):`<p class="mpc-small">${esc(this.t('empty_list'))}</p>`;
      const p=this.items.find(i=>i.id===this.selected);
      this.q('[data-selection]').innerHTML=p?`<b>${E.type(p).name}</b><p class="mpc-position">${esc(this.t('position',{x:this.fmt(p.x/10),y:this.fmt(p.y/10)}))}</p><div class="mpc-edit-actions"><button type="button" data-action="left" aria-label="${esc(this.t('left'))}">←</button><button type="button" data-action="right" aria-label="${esc(this.t('right'))}">→</button><button type="button" data-action="duplicate">${esc(this.t('duplicate'))}</button><button type="button" data-action="remove">${esc(this.t('remove'))}</button></div>`:`<p>${esc(this.t('none'))}</p>`;
      this.q('[data-saved]').textContent=this.t(this.storage?'saved':'storage_unavailable');this.scene();
    }
    shape(p,ghost=false){
      const t=E.type(p),x=p.x,y=this.wall.h-p.y-E.height(t),w=t.w,h=t.h,lift=E.height(t)-h,pf=this.prefix;
      const selected=p.id===this.selected,stroke=ghost?(this.ghost.ok?'#aceaf8':'#ff846c'):selected?'#ff851b':'#627884';
      const glazing=`<path d="M${x+21} ${y+h-30} L${x+w*.6} ${y+23} L${x+w*.7} ${y+23} L${x+32} ${y+h-30}Z" fill="#d3f1fa" opacity=".07"/><path d="M${x+18} ${y+21} H${x+w-18} V${y+h-25}" fill="none" stroke="#cfedf6" stroke-width="1.5" opacity=".5"/>`;
      const label=t.w>=240?t.name:t.name.split(' ').join(' '),fs=t.w>=240?21:16;
      const handle=ghost?'':`data-pod="${p.id}" role="button" tabindex="0" aria-pressed="${selected}" aria-label="${esc(t.name+' · '+this.t('position',{x:this.fmt(x/10),y:this.fmt(p.y/10)}))}"`;
      return `<g ${handle} ${ghost?'opacity=".65" pointer-events="none"':''}>${lift?`<path d="M${x+6} ${y+h}v${lift}m${w-12} 0v${-lift}" fill="none" stroke="#17242d" stroke-width="12"/>`:""}<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="3" fill="#d0d5d6"/><rect x="${x+8}" y="${y+9}" width="${w-16}" height="${h-26}" fill="url(#${pf}-mdf)"/><path d="M${x+13} ${y+15} L${x+28} ${y+30} V${y+h-34} L${x+13} ${y+h-23}Z" fill="#756550"/><path d="M${x+w-13} ${y+15} L${x+w-28} ${y+30} V${y+h-34} L${x+w-13} ${y+h-23}Z" fill="#998771"/><path d="M${x+13} ${y+h-23} L${x+28} ${y+h-34} H${x+w-28} L${x+w-13} ${y+h-23}Z" fill="#b7a68e"/>${this.light?`<rect x="${x+17}" y="${y+19}" width="${w-34}" height="${h-42}" fill="url(#${pf}-light)"/><rect x="${x+25}" y="${y+19}" width="${w-50}" height="3" rx="1" fill="#c7fbff"/>`:''}<rect x="${x+10}" y="${y+8}" width="${w-20}" height="8" fill="#e5e8e8"/><rect x="${x+10}" y="${y+h-23}" width="${w-20}" height="12" fill="#cbd1d0"/><rect x="${x}" y="${y}" width="12" height="${h}" rx="3" fill="url(#${pf}-rail)"/><rect x="${x+w-12}" y="${y}" width="12" height="${h}" rx="3" fill="url(#${pf}-rail)"/><rect x="${x}" y="${y}" width="14" height="4" rx="1" fill="#1f2a30"/><rect x="${x+w-14}" y="${y}" width="14" height="4" rx="1" fill="#1f2a30"/>${glazing}${['double','horizon'].includes(t.key)?`<rect x="${x+w/2-6}" y="${y+h-25}" width="12" height="6" rx="1" fill="#1d2730"/>`:''}<text x="${x+w/2}" y="${y+h/2+6}" text-anchor="middle" fill="${this.light?'#d4f4f8':'#e5e5df'}" opacity=".75" font-family="Arial, sans-serif" font-size="${fs}" letter-spacing="1">${label}</text><rect class="mpc-focus" x="${x-1}" y="${y-1}" width="${w+2}" height="${h+lift+2}" rx="4" fill="none" stroke="${stroke}" stroke-width="${selected||ghost?4:1}"/></g>`;
    }
    sides(p){const t=E.type(p),x=p.x,y=this.wall.h-p.y-E.height(t),dx=t.d*.27,dy=-t.d*.18;return `<g><path d="M${x} ${y} L${x+dx} ${y+dy} H${x+t.w+dx} L${x+t.w} ${y}Z" fill="#bac5c8" stroke="#71838c" stroke-width="1"/><path d="M${x+t.w} ${y} L${x+t.w+dx} ${y+dy} V${y+t.h+dy} L${x+t.w} ${y+t.h}Z" fill="#7f949e" stroke="#71838c" stroke-width="1"/><path d="M${x+t.w+dx} ${y+dy} V${y+E.height(t)+dy}" stroke="#14222e" stroke-width="8"/></g>`}
    scene(){
      const focusId=document.activeElement?.dataset?.pod,pf=this.prefix,W=this.wall.w,H=this.wall.h;
      let grid='';for(let x=0;x<=W;x+=100)grid+=`<line x1="${x}" y1="0" x2="${x}" y2="${H}" stroke="#b5dbeb" opacity="${x%500===0?.1:.045}"/>`;for(let y=0;y<=H;y+=100)grid+=`<line x1="0" y1="${H-y}" x2="${W}" y2="${H-y}" stroke="#b5dbeb" opacity="${y%500===0?.1:.045}"/>${y%500===0?`<text x="-23" y="${H-y+8}" text-anchor="end" font-size="24" fill="#87a8bc">${y/10}</text>`:''}`;
      const ordered=[...this.items].sort((a,b)=>a.y-b.y||a.x-b.x),svg=`<svg xmlns="${NS}" viewBox="-85 -90 ${W+220} ${H+180}" style="width:${this.zoom*100}%;height:${this.zoom*100}%" role="group" aria-label="${esc(this.t('canvas_label'))}"><defs><linearGradient id="${pf}-mdf" x2="0" y2="1"><stop stop-color="#6c6254"/><stop offset="1" stop-color="#99866d"/></linearGradient><linearGradient id="${pf}-rail"><stop stop-color="#080f17"/><stop offset=".7" stop-color="#27343d"/><stop offset="1" stop-color="#101a22"/></linearGradient><linearGradient id="${pf}-light" x2="0" y2="1"><stop stop-color="#98f5ff" stop-opacity=".68"/><stop offset="1" stop-color="#5cd6e3" stop-opacity=".15"/></linearGradient></defs><rect x="-85" y="-90" width="${W+220}" height="${H+180}" fill="#102338"/><rect x="0" y="0" width="${W}" height="${H}" fill="#152e43" stroke="#517089" stroke-dasharray="7 12"/>${grid}<path d="M0 -39 V-52 H${W} V-39" fill="none" stroke="#8bb4c8" stroke-width="2"/><text x="${W/2}" y="-65" text-anchor="middle" font-family="Arial, sans-serif" font-size="30" fill="#c3e2ef">${this.cm(W)}</text><text x="-23" y="-18" text-anchor="end" font-family="Arial, sans-serif" font-size="20" fill="#87a8bc">cm</text><path d="M0 ${H+2} H${W}" stroke="#84a4b9" stroke-width="3"/><ellipse cx="${W*.5}" cy="${H+15}" rx="${W*.47}" ry="19" fill="#060f19" opacity=".5"/>${this.view==='space'?ordered.map(p=>this.sides(p)).join(''):''}${ordered.map(p=>this.shape(p)).join('')}${this.ghost?this.shape(this.ghost.pod,true):''}<text x="${W}" y="${H+64}" font-family="Arial, sans-serif" font-size="23" fill="#89aabe" text-anchor="end">${this.cm(W)} × ${this.cm(H)} · BIMM MODELLBAU</text></svg>`;
      this.stage.innerHTML=svg;if(focusId)this.stage.querySelector(`[data-pod="${focusId}"]`)?.focus({preventScroll:true});
    }
  }
  function init(scope){scope.querySelectorAll('[data-modelpod-wall]').forEach(root=>new WallPlanner(root))}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modelpod-wiring"]) return;
  try {
    

function initModelpodWiring(root){
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  const players=[...root.querySelectorAll('video')],status=root.querySelector('.mpw-status');
  for(const player of players)player.addEventListener('play',()=>{for(const other of players)if(other!==player)other.pause()});
  for(const button of root.querySelectorAll('[data-video]'))button.addEventListener('click',()=>{
    const player=document.getElementById(button.dataset.video);
    const seekAndPlay=async()=>{player.currentTime=Number(button.dataset.time);try{await player.play();status.textContent=root.dataset.playing}catch{status.textContent=root.dataset.playManual}};
    if(player.readyState>=1)seekAndPlay();else{player.addEventListener('loadedmetadata',seekAndPlay,{once:true});player.load()}
  });
}
document.querySelectorAll('.mp-wiring').forEach(initModelpodWiring);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.mp-wiring').forEach(initModelpodWiring));


  } catch(e) { console.error(e); }
})();
})();
